// assets/sq-megamenu-a11y.js
(function () {
  // ✅ 중복 실행 방지
  if (window.__SQ_MEGA_A11Y_V3__) return;
  window.__SQ_MEGA_A11Y_V3__ = true;

  // ===== Selectors =====
  const HEADER_SELECTOR = ".sf-header.m-header";
  const MEGA_ITEM_SELECTOR = ".m-menu__item--mega";
  const TRIGGER_SELECTOR = `${MEGA_ITEM_SELECTOR} > a[aria-haspopup="true"][aria-controls]`;
  const MENU_SELECTOR = ".sf-menu__submenu";
  const TAB_SELECTOR = 'li[data-index] > a.sf__sub-menu-link2';
  const PANEL_SELECTOR = ".sf-mega-menu-collections[data-index]";

  const focusableSelector = [
    'a[href]:not([tabindex="-1"])',
    'button:not([disabled]):not([tabindex="-1"])',
    'input:not([disabled]):not([tabindex="-1"])',
    'select:not([disabled]):not([tabindex="-1"])',
    'textarea:not([disabled]):not([tabindex="-1"])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(",");

  function isArrowKey(key) {
    return key === "ArrowUp" || key === "ArrowDown" || key === "ArrowLeft" || key === "ArrowRight";
  }

  function isEditableTarget(target) {
    if (!(target instanceof HTMLElement)) return false;
    return (
      target.isContentEditable ||
      target.tagName === "INPUT" ||
      target.tagName === "TEXTAREA" ||
      target.tagName === "SELECT"
    );
  }

  function getSubmenuByTrigger(trigger) {
    const id = trigger.getAttribute("aria-controls");
    if (!id) return null;
    return document.getElementById(id);
  }

  function openMega(trigger) {
    const parentLi = trigger.closest(MEGA_ITEM_SELECTOR);
    const submenu = getSubmenuByTrigger(trigger);
    const header = document.querySelector(HEADER_SELECTOR);

    if (!parentLi || !submenu || !header) return;

    // 열기 상태 세팅
    parentLi.classList.add("sf-menu-item--active");
    header.classList.add("st-nega-active");
    submenu.classList.remove("pointer-events-none");
    trigger.setAttribute("aria-expanded", "true");

    // 기본 탭(0번) 보이게 정리
    resetMenuToFirstTab(submenu);

    // 좌측 첫 탭으로 포커스 (키보드 진입 포인트)
    const firstTab =
      submenu.querySelector('li[data-index="0"] > a.sf__sub-menu-link2') ||
      submenu.querySelector(TAB_SELECTOR);

    if (firstTab) firstTab.focus();
  }

  function closeMega(trigger, { focusBack = true } = {}) {
    const parentLi = trigger.closest(MEGA_ITEM_SELECTOR);
    const submenu = getSubmenuByTrigger(trigger);
    const header = document.querySelector(HEADER_SELECTOR);

    if (!parentLi || !submenu || !header) return;

    parentLi.classList.remove("sf-menu-item--active");
    submenu.classList.add("pointer-events-none");
    trigger.setAttribute("aria-expanded", "false");

    // 다른 mega가 열려있지 않으면 header 클래스 제거
    const anyOpen = document.querySelector(`${TRIGGER_SELECTOR}[aria-expanded="true"]`);
    if (!anyOpen) header.classList.remove("st-nega-active");

    // 닫힐 때 기본 탭으로 리셋
    resetMenuToFirstTab(submenu);

    if (focusBack) trigger.focus();
  }

  function closeAllMega({ exceptTrigger = null } = {}) {
    document.querySelectorAll(TRIGGER_SELECTOR).forEach((tr) => {
      if (exceptTrigger && tr === exceptTrigger) return;
      if (tr.getAttribute("aria-expanded") === "true") closeMega(tr, { focusBack: false });
    });
  }

  // ===== Tabs (Left) -> Panels (Right) =====
  function getIndexFromTab(tab) {
    const li = tab.closest("li[data-index]");
    return li ? li.dataset.index : null;
  }

  function activateTabInMenu(submenu, index, { focusFirst = false } = {}) {
    if (!submenu || index == null) return;

    // 1) 좌측 탭 active
    submenu.querySelectorAll("li[data-index]").forEach((li) => {
      const a = li.querySelector("a.sf__sub-menu-link2");
      const active = li.dataset.index === String(index);

      li.classList.toggle("sf-menu2-item--active", active);

      if (a) {
        a.setAttribute("role", "tab");
        a.setAttribute("aria-selected", active ? "true" : "false");
        a.setAttribute("tabindex", "0"); // 기존 UX 유지
      }
    });

    // 2) 우측 패널 show/hide
    submenu.querySelectorAll(PANEL_SELECTOR).forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.index !== String(index));
    });

    // 3) 필요 시 우측 첫 포커스
    if (focusFirst) {
      const targetPanel = submenu.querySelector(`${PANEL_SELECTOR}[data-index="${index}"]`);
      const firstFocusable = targetPanel?.querySelector(focusableSelector);
      firstFocusable?.focus();
    }
  }

  function resetMenuToFirstTab(submenu) {
    if (!submenu) return;

    const firstTab =
      submenu.querySelector('li[data-index="0"] > a.sf__sub-menu-link2') ||
      submenu.querySelector(TAB_SELECTOR);

    if (!firstTab) return;

    const idx = getIndexFromTab(firstTab) ?? "0";
    activateTabInMenu(submenu, idx, { focusFirst: false });
  }

  // ===== (A) 키보드로 1뎁스 Mega Menu 열기/닫기 =====
  // - Enter/Space: 토글 (키보드 접근용)
  // - Escape: 닫기
  document.addEventListener(
    "keydown",
    (e) => {
      const trigger = e.target.closest(TRIGGER_SELECTOR);
      if (!trigger) return;

      if (e.key === "Enter" || e.key === " ") {
        // 키보드로 열 때는 링크 이동 막고 "메뉴 열기"로 사용
        e.preventDefault();
        e.stopPropagation();

        const expanded = trigger.getAttribute("aria-expanded") === "true";
        if (expanded) {
          closeMega(trigger);
        } else {
          closeAllMega({ exceptTrigger: trigger });
          openMega(trigger);
        }
      }

      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
        closeMega(trigger);
      }
    },
    true
  );

  // ===== (B) Mega 내부에서 ESC로 닫기 (포커스가 submenu 안에 있을 때도) =====
  document.addEventListener(
    "keydown",
    (e) => {
      if (e.key !== "Escape") return;

      const inside = e.target.closest(MENU_SELECTOR);
      if (!inside) return;

      const trigger = document.querySelector(`${TRIGGER_SELECTOR}[aria-controls="${inside.id}"]`);
      if (!trigger) return;

      e.preventDefault();
      e.stopPropagation();
      closeMega(trigger);
    },
    true
  );

  // ===== (C) 포커스가 Mega 밖으로 나가면 닫기 (너무 공격적이면 빼도 됨) =====
  let focusOutTimer = null;
  document.addEventListener(
    "focusin",
    () => {
      if (focusOutTimer) clearTimeout(focusOutTimer);
      focusOutTimer = null;
    },
    true
  );

  document.addEventListener(
    "focusout",
    () => {
      // 다음 activeElement가 어디로 가는지 확인하기 위해 살짝 지연
      focusOutTimer = setTimeout(() => {
        const active = document.activeElement;

        // 열린 메뉴가 있으면, 그 메뉴/트리거 내부에 active가 없을 때만 닫기
        document.querySelectorAll(`${TRIGGER_SELECTOR}[aria-expanded="true"]`).forEach((trigger) => {
          const submenu = getSubmenuByTrigger(trigger);
          const parentLi = trigger.closest(MEGA_ITEM_SELECTOR);

          const stillInside =
            (parentLi && parentLi.contains(active)) || (submenu && submenu.contains(active));

          if (!stillInside) closeMega(trigger, { focusBack: false });
        });
      }, 80);
    },
    true
  );

  // ===== (D) 좌측 탭: Enter/Space만 패널 전환, "진짜 링크"는 클릭 이동 허용 =====
  document.addEventListener(
    "keydown",
    (e) => {
      const tab = e.target.closest(TAB_SELECTOR);
      if (!tab) return;

      // 좌측 탭에서 방향키는 완전 비활성화
      if (isArrowKey(e.key)) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      // Enter/Space로만 탭 전환
      if (e.key !== "Enter" && e.key !== " ") return;

      // 키보드에서 Enter/Space는 "탭 전환" 목적 → 이동 막고 패널 전환
      e.preventDefault();
      e.stopPropagation();

      const submenu = tab.closest(MENU_SELECTOR);
      const index = getIndexFromTab(tab);
      if (!submenu || index == null) return;

      activateTabInMenu(submenu, index, { focusFirst: true });
    },
    true
  );

  document.addEventListener(
    "click",
    (e) => {
      const tab = e.target.closest(TAB_SELECTOR);
      if (!tab) return;

      const href = tab.getAttribute("href") || "";

      // ✅ "진짜 링크"면 클릭 네비게이션 허용
      const isRealLink =
        href &&
        href !== "#" &&
        !href.startsWith("javascript:") &&
        !href.startsWith("#");

      if (isRealLink) return;

      // 탭용 링크(# 등)만 패널 전환
      e.preventDefault();
      e.stopPropagation();

      const submenu = tab.closest(MENU_SELECTOR);
      const index = getIndexFromTab(tab);
      if (!submenu || index == null) return;

      activateTabInMenu(submenu, index, { focusFirst: false });
      tab.focus();
    },
    true
  );

  // ===== (E) 오른쪽 패널: 방향키 비활성화 (단, 입력창은 예외) =====
  document.addEventListener(
    "keydown",
    (e) => {
      const inside = e.target.closest(MENU_SELECTOR);
      if (!inside) return;

      // 좌측 탭은 위에서 처리
      if (e.target.closest(TAB_SELECTOR)) return;

      if (!isArrowKey(e.key)) return;
      if (isEditableTarget(e.target)) return;

      e.preventDefault();
      e.stopPropagation();
    },
    true
  );

  // ===== (F) 초기화: 모든 submenu 기본 탭으로 정리 =====
  document.querySelectorAll(MENU_SELECTOR).forEach((submenu) => resetMenuToFirstTab(submenu));
})();
